// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qpsb","index":"styles_index__8KDDh"};